/**
 * `identity_tags` is the API's identity vocabulary, served on every route that
 * builds the auth-context user: a sorted array of lowercase tag strings such as
 * ['scholar', 'student'] — the union of what a user's legacy role rows, roster
 * seats and grants each say they are, with 'professional' appended when no lane
 * says student. It is never empty for a user that exists.
 *
 * The legacy `protege` half below is load-bearing rather than redundant: a legacy
 * protege with none of the Student, Scholar or Foundations role rows, no live
 * student seat and no identity-conferring grant has no lane producing a student
 * tag, so the API tags them `professional` and the tag half alone would not find
 * them.
 */
const isStudent = (user) => user?.role === 'protege' || !!user?.identity_tags?.includes('student');

export default isStudent;
